import React, { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import FormInput from "../../../utils/FormInput";
import { FormElementModel } from "../../models/FormElementModel";
import { State } from "../../store";
import useFinalizeManager from "../FinalizePage/hooks/useFinalizeManager";
import { invoiceForm } from "../FinalizePage/inputsForm/InputPayFormModels";
import InvoiceButtons from "../FinalizePage/InvoiceButtons";
import useMyAccount from "../MyAccount/hooks/useMyAccount";
import EcardDefinition from "./ecardDefinitions";
import useECard from "./hooks/useECard";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { userPayCheckboxForm } from "../FinalizePage/inputsForm/CheckboxPayFormModel";
import { PaymentLogos } from "../../../features/PaymentLogo";
import Timer from "../FinalizePage/Timer";
import BasketSummary from "../FinalizePage/BasketSummary";

export type InputsFinalize = {
  depositIds: string;
  firstName: string;
  lastName: string;
  email: string;
  repeatEmail: string;
  phone: string;
  city: string;
  street: string;
  houseNumber: string;
  flatNumber: string;
  zipCode: string;
  NIP: string;
  companyName: string;
  createUser: boolean;
  createInvoice: boolean;
  acceptEAktywni: boolean;
  acceptPrivacyPolicy: boolean;
  acceptStatute: boolean;
};

const CardRecharge: React.FC = () => {
  const { t } = useTranslation();
  const userData = useSelector((state: State) => state.auth.userData);
  const { acceptTransaction } = useFinalizeManager();

  const saleConfiguration = useSelector((state: State) => state.config.configuration);

  const { type, requestGetAssortGroups, requestPaymentDefinition, paymentUrl } = useECard();
  const [invoiceType, setInvoiceType] = useState<
    "noInvoice" | "customerInvoice" | "companyInvoice" | "recipientAndPurchaserInvoice"
  >("noInvoice");

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm<InputsFinalize>({
    defaultValues: userData,
  });

  const handleRegistration: SubmitHandler<InputsFinalize> = async (data: any) => {
    requestPaymentDefinition({ ...data, createInvoice: invoiceType !== "noInvoice" }, activeDefinition);
  };

  useEffect(() => {
    requestGetAssortGroups();
  }, []);

  const [activeDefinition, setActiveDefinition] = useState(999);
  const [activeDefinitionPrice, setActiveDefinitionPrice] = useState(0);

  const handleState = (num: number, price: number) => {
    setActiveDefinition(num);
    setActiveDefinitionPrice(price);
  };

  const handleStateDisable = (num: number, price: number) => {};

  useMyAccount();

  return (
    <React.Fragment>
      {userData && (
        <form className="card-recharge flex-between" onSubmit={handleSubmit(handleRegistration)}>
          <div className="padding-big box shadow border">
            <h3>{t("wybierz_doladowanie")}</h3>
            <div className="ecard-definitions flex-column ">
              {type && (
                <React.Fragment>
                  {paymentUrl === "" ? (
                    <React.Fragment>
                      {type.map((item, index) => (
                        <EcardDefinition
                          key={index}
                          item={item}
                          handleState={handleState}
                          activeDefinition={activeDefinition}
                        />
                      ))}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {type.map((item, index) => (
                        <EcardDefinition
                          key={index}
                          item={item}
                          handleState={handleStateDisable}
                          activeDefinition={activeDefinition}
                        />
                      ))}
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
            </div>

            {saleConfiguration.invoiceActive && (
              <React.Fragment>
                <h3>{t("faktura")}</h3>
                <InvoiceButtons invoiceType={invoiceType} setInvoiceType={setInvoiceType} />
              </React.Fragment>
            )}
          </div>

          <div className="padding-big box shadow border">
            {invoiceType !== "noInvoice" && (
              <div>
                <h3>{t("dane_do_faktury")}</h3>
                <div className={"inputs-customer-invoice"}>
                  {invoiceForm(register, invoiceType === "companyInvoice").map(
                    (item: FormElementModel, index: number) =>
                      item.name && <FormInput key={index} {...item} errors={errors} />
                  )}
                </div>
              </div>
            )}

            {invoiceType === "noInvoice" && (
              <div>
                <h3>{t("zgody")}</h3>
                {userPayCheckboxForm(errors, control, setValue).map((item, index) => (
                  <div className="flex-start-center" key={index}>
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="padding-big box shadow border">
            {invoiceType !== "noInvoice" && (
              <div>
                <h3>{t("zgody")}</h3>
                {userPayCheckboxForm(errors, control, setValue).map((item, index) => (
                  <div className="flex-start-center" key={index}>
                    {item}
                  </div>
                ))}
              </div>
            )}

            <BasketSummary total={activeDefinitionPrice} />

            {alert.length > 2 && <div className="alert alert-red">{alert}</div>}
            {/* <input
            className={"button button-fill-second big full-button move-up"}
            type={"submit"}
            value={"Kupuję i płacę"}
          /> */}

            <React.Fragment>
              {paymentUrl === "" ? (
                <input
                  className={"button button-fill-second big full-button move-up"}
                  type={"submit"}
                  value={t("kupuje_z_obowiazkiem_zaplaty")}
                />
              ) : (
                <React.Fragment>
                  {paymentUrl && (
                    <a target="_blank" className="button button-fill-second big full-button move-up" href={paymentUrl}>
                      {" "}
                      {t("przejdz_do_platnosci")}
                    </a>
                  )}

                  <span className="small-akapit">
                    {t("za_chwile_zostaniesz_automatycznie_przeniesiony_do_systemu_platnosci")}
                  </span>
                </React.Fragment>
              )}
            </React.Fragment>

            <Timer />

            <PaymentLogos />
          </div>

          {/* <div className="headline">
            <h1>
              {t("doladowujesz")} {saleConfiguration.giftCard2Message}
            </h1>
            <div className="line"></div>
          </div>

          <div className="flex-column flex-wrap">
            <div className="step-one">
              <h3>
                {t("twoja")} {saleConfiguration.giftCard1Message}
              </h3>
              <EcardBar />
            </div>

            <div className="step-two">
              <h3>{t("wybierz_doladowanie")} </h3>
              <div className="ecard-definitions flex-start">
                {type && (
                  <React.Fragment>
                    {type.map((item, index) => (
                      <EcardDefinition
                        key={index}
                        item={item}
                        handleState={handleState}
                        activeDefinition={activeDefinition}
                      />
                    ))}
                  </React.Fragment>
                )}
              </div>
            </div>
            {activeDefinition !== 999 && (
              <React.Fragment>
                <div className="step-three">
                  <h3>{t("wybierz_potwierdzenie")} </h3>
                  <div className="ecard-invoice flex-start">
                    <InvoiceButtons invoiceType={invoiceType} setInvoiceType={setInvoiceType} />
                  </div>
                </div>
                <div className="step-three flex-start flex-wrap">
                  <h3>{t("dane_kupujacego")}</h3>

                  <div className="user-data">
                    <h4>{t("jestes_zalogowany")}</h4>
                    <div>
                      <div className="form">
                        <input type="text" value={userData.firstName} />
                        <input type="text" value={userData.email} />
                        <input type="text" value={userData.phone} />
                      </div>
                    </div>
                  </div>

                  {invoiceType != "noInvoice" && (
                    <div className="invoice-data">
                      <div>
                        <h3>{t("dane_do_faktury")}</h3>
                        <div className={"inputs-customer-invoice"}>
                          {invoiceForm(register, invoiceType === "companyInvoice").map(
                            (item: FormElementModel, index: number) =>
                              item.name && <FormInput key={index} {...item} errors={errors} />
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="separator"></div>

                <div className="buttons flex-end-center">
                  <Link to={LOGIN_PAGE}>
                    <button className="button big padding-big button-text-main">{t("wstecz")}</button>
                  </Link>
                  <button className={"button big padding-big button-fill-main"} type={"submit"}>
                    {t("przejdz_do_platnosci")} <RiSecurePaymentLine className="icon" />
                  </button>
                </div>
              </React.Fragment>
            )}
          </div> */}
        </form>
      )}
    </React.Fragment>
  );
};

export default CardRecharge;
